export function navigateToLoginPage(appUrl: string, loginUrl: string) {
    const callBackUrl = encodeURIComponent(appUrl);
    const url = loginUrl + '/login/' + callBackUrl;
    window.location.href = url;
}
